module.exports = __webpack_public_path__ + "static/media/pro-2.b5e632fe.png";